import { Component, ElementRef, Input, TemplateRef } from '@angular/core';
import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-attention-modal',
  templateUrl: 'attention-modal.component.html',
  standalone: true,
  imports: [NgClass, NgIf, NgTemplateOutlet],
})
export class AttentionModalComponent {
  @Input() type!: 'warning' | 'error' | 'success' | 'scheduled';

  @Input() title!: string;

  @Input() subtitle?: string;

  @Input() messageTemplate!: TemplateRef<ElementRef>;

  @Input() buttonsTemplate!: TemplateRef<ElementRef>;
}
